import { CxmRulesClientHeader } from '../types/cxm-rules-client-header';
/**
 * Gets the [[HttpRequestConfiguration]] for a particular API request, including request-specific headers.
 *
 * Merges the provided [[CxmRulesClientConfig]] `authToken` and [[HttpRequestConfiguration]].
 */
export const getRequestConfig = async (config, requestConfig) => {
    const headers = new Headers(requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.headers);
    const authToken = await config.authTokenProvider();
    headers.append(CxmRulesClientHeader.Authorization, `Bearer ${authToken}`);
    return Object.assign(Object.assign({}, requestConfig), { headers });
};
//# sourceMappingURL=get-request-config.js.map